import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KoachCoaching: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // 코칭 메인 페이지 접근 시 성장 다이어리로 리다이렉트
        navigate('/koach/coaching/diary', { replace: true });
    }, [navigate]);

    return null;
};

export default KoachCoaching;